import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ForecastBannerText } from '../models';
import { IqTrendlinesGraphRatesStateService } from '../state';
@Component({
    selector: 'iq-trendlines-graph-rates-forecast-banner',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './iq-trendlines-graph-rates-forecast-banner.component.html',
    styleUrl: './iq-trendlines-graph-rates-forecast-banner.component.scss',
})
export class IqTrendlinesGraphRatesForecastBannerComponent {
    private _state = inject(IqTrendlinesGraphRatesStateService);
    readonly bannerText: string = ForecastBannerText;

    redirectToIqRateView(): void {
        this._state.dipstachUpsellSegmentEvent();
    }
}
